import React from "react";
import { default as WInput } from "@mui/material/Input";

function Input(props) {
  return <WInput {...props} />;
}

export default Input;
